import type { PrivateUserInfoType } from '@otw/models';

const lastActivityDateTimeFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

/** Date and time for grid "Last activity" columns (most recent activity timestamp). */
export const formatLastActivityDateTime = (date: Date | null | undefined): string => {
  if (!date) return '—';
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '—';
  return lastActivityDateTimeFormatter.format(d);
};

/** Resolve a portal user's display name from an activity's `createdByUserId`. */
export const activityAuthorDisplayName = (
  users: PrivateUserInfoType[] | undefined,
  createdByUserId: string | undefined,
): string | null => {
  const id = createdByUserId?.trim();
  if (!id) return null;
  const user = users?.find((u) => String(u.id) === id);
  if (!user) return id;
  const name = `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim();
  return name || user.email || id;
};
